import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
export default {
  install(Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HP_DPT_API + '/users-hub')
      .configureLogging(LogLevel.Information)
      .build();

    let startedPromise = null;
    function start() {
      startedPromise = connection.start().catch((err) => {
        console.error('Failed to connect with hub', err);
        return new Promise((resolve, reject) =>
          setTimeout(() => start().then(resolve).catch(reject), 5000)
        );
      });
      return startedPromise;
    }
    connection.onclose(() => start());

    start();

    // use new Vue instance as an event bus
    const usersHub = new Vue();
    // every component will use this.$questionHub to access the event bus
    Vue.prototype.$usersHub = usersHub;
    // Forward server side SignalR events through $questionHub, where components will listen to them
    connection.on('FixedDatesUpdated', () => {
      usersHub.$emit('dashboard-dates-updated');
    });

    connection.on('FeedbackTasksUpdated', () => {
      usersHub.$emit('dashboard-tasks-updated');
    });

    connection.on('RecipientProcessesUpdated', () => {
      usersHub.$emit('recipient-processes-updated');
    });

    connection.on('DonorProcessesUpdated', () => {
      usersHub.$emit('donor-processes-updated');
    });

    usersHub.joinUserGroup = (userId) => {
      if (!startedPromise) return;

      return startedPromise
        .then(() => connection.invoke('JoinUserGroup', userId))
        .catch(console.error);
    };

    usersHub.leaveUserGroup = (userId) => {
      if (!startedPromise) return;

      return startedPromise
        .then(() => connection.invoke('LeaveUserGroup', userId))
        .catch(console.error);
    };
  }
};
